import {
  ComplaintColumnValues,
  IComplaintColumn,
} from "./complaintColumn.types"

export class ComplaintColumn implements IComplaintColumn {
  constructor({
    channel,
    type,
    team,
    agentName,
    status,
    subStatus,
    category1,
    category2,
    category3,
    ofgemCategory,
    internalCategory,
  }: {
    channel: ComplaintColumnValues
    type: ComplaintColumnValues
    team: ComplaintColumnValues
    agentName: ComplaintColumnValues
    status: ComplaintColumnValues
    subStatus: ComplaintColumnValues
    category1: ComplaintColumnValues
    category2: ComplaintColumnValues
    category3: ComplaintColumnValues
    ofgemCategory: ComplaintColumnValues
    internalCategory: ComplaintColumnValues
  }) {
    this.channel = channel
    this.type = type
    this.team = team
    this.agentName = agentName
    this.status = status
    this.subStatus = subStatus
    this.category1 = category1
    this.category2 = category2
    this.category3 = category3
    this.ofgemCategory = ofgemCategory
    this.internalCategory = internalCategory
  }

  [key: string]: { [key: string]: string }
}
